import { rootApi } from "@/services/api/api";
import type {
  RegisterInitRequest,
  RegisterInitResponse,
  SendSmsRequest,
  VerifySmsRequest,
} from "../types";

export const registrationApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    registerInit: builder.mutation<RegisterInitResponse, RegisterInitRequest>({
      query: (body) => ({
        url: "/register/init",
        method: "POST",
        body,
      }),
    }),
    smsSend: builder.mutation<void, SendSmsRequest>({
      query: (body) => ({
        url: "/register/sms/send",
        method: "POST",
        body,
      }),
    }),
    smsVerify: builder.mutation<void, VerifySmsRequest>({
      query: (body) => ({
        url: "/register/sms/verify",
        method: "POST",
        body,
      }),
    }),
    getRegisterState: builder.query<any, { username: string }>({
      query: (body) => ({
        url: "/register/state",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useRegisterInitMutation,
  useSmsSendMutation,
  useSmsVerifyMutation,
  useLazyGetRegisterStateQuery,
} = registrationApi;
